import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-100 border-t border-gray-300 mt-16 text-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Company Info */}
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Misu Capital</h2>
            <p className="mt-4 text-sm leading-relaxed text-gray-600">
              Empowering individuals and businesses to make informed financial decisions with trusted advisory services.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-800">Quick Links</h3>
            <ul className="mt-2 space-y-1">
              <li>
                <Link to="/faq" className="text-sm hover:text-blue-600 transition-colors duration-200">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-blue-600 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-blue-600 transition-colors duration-200">
                  Contact
                </Link>
              </li>
              {/* Add more links as needed */}
            </ul>
          </div>

          {/* Legal Info */}
          <div className="text-sm md:text-right space-y-1">
            <p>© {new Date().getFullYear()} Misu Capital</p>
            <p className="text-gray-500">All rights reserved.</p>
            <p className="text-gray-500">
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
